export const setTranslationsToStorage = (translationsData: Object) => {
  localStorage.setItem('translations', JSON.stringify(translationsData));
};
